/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, Optional, ViewChild } from '@angular/core';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { FilterService } from '@progress/kendo-angular-grid';
import {
  CompositeFilterDescriptor,
  FilterDescriptor,
} from '@progress/kendo-data-query';
import { BaseCustomFilterComponent } from './base-custom-filter.component';

@Component({ standalone: false, 
  selector: 'dropdown-filter',
  template: `
    <kendo-dropdownlist
      #drop
      [showOperators]="true"
      [field]="field"
      [data]="data"
      (valueChange)="onChange($event)"
      [defaultItem]="defaultItem"
      [value]="selectedValue"
      [valuePrimitive]="true"
      [textField]="textField"
      [valueField]="valueField"
    >
    </kendo-dropdownlist>
  `,
})
export class DropDownFilterComponent extends BaseCustomFilterComponent {
  @ViewChild('drop', { read: DropDownListComponent })
  public list: DropDownListComponent;

  @Input() public filter: CompositeFilterDescriptor;
  @Input() public data: any[];
  @Input() public field: string;
  @Input() public textField: string;
  @Input() public valueField: string;

  public get selectedValue(): unknown {
    if (this.filter && this.filter.filters) {
      const filter = (this.filter.filters as FilterDescriptor[]).find(
        ({ field }) => {
          return field === this.field;
        },
      );

      if (filter && filter.value && this.data) {
        const item: any[] = this.data.filter((item) => {
          return item.id === filter.value;
        });

        if (item && item[0]) {
          return item[0].id;
        }
      }
      return null;
    }
  }

  public get defaultItem(): { [Key: string]: unknown } {
    return {
      [this.textField]: 'Select...',
      [this.valueField]: null,
    };
  }

  // Constructor needed for proper filter functioning
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(@Optional() filterService: FilterService) {
    super(filterService);
  }

  public resetDefault(): void {
    this.list.reset();
  }

  public onChange(value: unknown): void {
    this.applyFilter(
      value === null // value of the default item
        ? this.removeFilter(this.field) // remove the filter
        : this.updateFilter({
            // add a filter for the field with the value
            field: this.field,
            operator: 'eq',
            value: value,
          }),
    ); // update the root filter
  }
}
